import React from "react"
import { Link } from "react-router-dom"
import { Icon } from "../Icon"
import { container, currentPageStyle, separator } from "./styles"

export interface BreadcrumbsProps {
	pages?: {
		name: string
		to?: string
	}[]
}

export const BreadcrumbsEcomm: React.FC<BreadcrumbsProps> = React.memo(({ pages = [] }) => {
	return (
		<nav css={container} aria-label="Breadcrumb">
			{pages.length > 0 && (
				<ul>
					<li>
						<Link to="/" aria-label="Home">
							Home
						</Link>
					</li>
					{pages.map(({ name, to }, i) => (
						<React.Fragment key={name}>
							<li aria-hidden="true">
								<Icon icon="chevron-right" css={separator} aria-hidden="true" />
							</li>
							<li>
								{i === pages.length - 1 ?
									<Link
										to={to ?? "/"}
										aria-current="page"
										css={currentPageStyle}
									>
										{name}
									</Link>
								:	<Link to={to ?? "/"}>{name}</Link>}
							</li>
						</React.Fragment>
					))}
				</ul>
			)}
		</nav>
	)
})
